import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/QualityControl/defaultRequestOptions'

import TaskListTemplateEditRoutes from './routes'

const TaskListTemplateEdit = () => {
  const { taskListTemplateId } = useNumericParams()

  useReduxAction(
    'taskListTemplates',
    'loadTaskListTemplate',
    {
      entityId: taskListTemplateId,
      ...defaultRequestOptions.taskListTemplate,
    },
    [taskListTemplateId],
    {
      dispatchAction: (action, requestOptions) => action(taskListTemplateId, requestOptions),
      // @ts-expect-error TS2339
      shouldPerformFn: ({ loading }) => taskListTemplateId && !loading,
    },
  )

  return (
    <TaskListTemplateEditRoutes />
  )
}

export default TaskListTemplateEdit
